<c-card class=" mb-2" *transloco="let t">
    <c-card-body>

            <c-row>
              <c-col md="12">
                  <h1>{{ t('Your Free Trial has Expired') }}</h1>
                <p>
                    {{ t('Your free trial expired on ') }}{{okService.billing.trial_end}}.
                </p>
                <p>
                    {{ t('To talk about extending your free trial or going live, please email us at ') }}<a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>.
                </p>

              </c-col>
            </c-row>
    </c-card-body>
</c-card>

